<script lang="ts">
  import { xhr, toast } from "$app/utils"
  import Button from "$app/components/ButtonSpinner.svelte"
  import Navigation from "./Navigation.svelte"
  import { appStore } from "$app/store.svelte"

  let { onUpdateStep, onUpdateUser } = $props()

  let errors = $state({})

  let saving = $state(false)
  async function updateUser() {
    saving = true
    errors = {}
    const formData = new FormData()
    formData.append("user[onboarding_steps][welcome]", "true")
    try {
      const resp = await xhr.patch(
        `/user_onboarding/${appStore.current_user.id}`,
        formData
      )
      onUpdateUser(resp.data)
    } catch (e) {
      console.error(e.response)
      toast("There was an error", "error")
      if (e.response) {
        errors = { ...errors, ...e.response.data.errors }
      }
    } finally {
      saving = false
    }
  }
</script>

<div class="mx-auto px-2 lg:px-6 pt-4 w-full pb-6 lg:pb-10 lg:text-left">
  <div class="px-4 w-full">
    <Navigation step="welcome" {onUpdateStep} />

    <div class="px-6 lg:px-12 my-8 w-full max-w-5xl mx-auto">
      <h2 class="mt-6 text-4xl font-bold text-center text-white">
        Welcome Aboard!
      </h2>
      <h3 class="mt-4 text-xl text-white mb-6 text-center max-w-3xl mx-auto">
        Watch this welcome message from our Vice President of Client Experience,
        Anja Koehler, and then click <span class="font-bold text-green-200"
          >Continue</span
        > to proceed.
      </h3>

      <div class="relative max-w-3xl mx-auto" style="padding-top: 44.25%">
        <iframe
          src="https://player.vimeo.com/video/1001297573"
          class="absolute inset-0 w-full h-full"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
          style="position:absolute;top:0;left:0;width:100%;height:100%;"
          title="E1 Course"
        ></iframe>
      </div>
      <div class="mt-4 lg:mt-6 w-full">
        <div class="text-center py-4">
          <Button
            onclick={updateUser}
            processing={saving}
            class="btn-rounded bg-green-600 hover:bg-green-700 text-white btn-big w-full text-lg font-bold md:w-60 h-14"
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  </div>
</div>
